import { List } from 'immutable';
import {
  FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS,
  FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS,
} from './actions';
import AcademicInfoGroupModel from './AcademicInfoGroup';
import ConcernsStudentSkillModel from './ConcernsStudentSkill';

export default function academicInfoGroups(state = new List(), action) {
  switch (action.type) {
    case FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS:
      return onAcademicInfoGroupListSuccess(state, action);
    default:
      return state;
  }

  function onAcademicInfoGroupListSuccess() {
    const newGroupList = new List(action.payload.map((academicInfoGroup) =>
      AcademicInfoGroupModel.create(Object.assign(
        academicInfoGroup,
        { isTodayGroup: ! action.isAllGroups }
      ))));

    if (state.size === 0) return newGroupList;

    let allGroups;
    let todayGroups;
    if (action.isAllGroups) {
      allGroups = newGroupList;
      todayGroups = state;
    } else {
      allGroups = state;
      todayGroups = newGroupList;
    }
    return allGroups.map((group) => {
      const matchedGroup = todayGroups.find((todayGroup) => todayGroup.id === group.id);
      return matchedGroup || group;
    });
  }
}

export function academicInfoConcernsStudentSkills(state = new List(), action) {
  switch (action.type) {
    case FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS:
      return new List(action.payload.map((studentSkill) =>
        ConcernsStudentSkillModel.create(studentSkill)));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/AcademicInfo/reducer.js